<template>
  <div class="smart-slider-locator-menu">
    <div class="header">
      <div class="title">Locators ({{ locatorType }})</div>
      <div class="controls">
        <c-dropdown
          v-show="locatorTypeEntries.length > 1"
          class="cursor-pointer"
          @select="selectLocator"
          :entries="locatorTypeEntries">
          <icon
            size="large"
            src="/icons/dots.svg">
          </icon>
        </c-dropdown>
      </div>
    </div>
    <template v-if="category">
      <smartSlider-locator
        :key="idx"
        class="mb-4"
        :in-preview="locator.thumbin"
        :locator="locator"
        @jump="$emit('jump', $event)"
        v-for="(locator, idx) in category?.locators?.locators">
        {{ locator?.note }}
      </smartSlider-locator>
    </template>
  </div>
</template>

<script>
  export default {
    props: [
      'categoryId',
    ],
    data() {
      return {
        category: null,
        locatorType: 'default',
        locatorTypeEntries: [],
      }
    },
    methods: {
      selectLocator($event) {
        this.locatorType = $event
      }
    },
    watch: {
      categoryId: {
        deep: true,
        immediate: true,
        async handler() {
          this.category = await this.$api.findCategory(this.categoryId)
          this.locatorTypeEntries = [{ id: 'default', label: 'Default '}].concat((this.category?.locators?.locatorTypes || []).map(locator => {
            return {
              id: locator.name,
              label: locator.name
            }
          }))
        }
      },
      locatorType: {
        async handler() {
          this.category = await this.$api.findCategory(this.categoryId, { loc: this.locatorType })
        }
      }
    },
    inject: [
      '$api',
    ]
  }
</script>

<style lang="scss" scoped>
  .smart-slider-locator-menu {
    .header {
      @apply
        mb-4
        flex
        w-full
        text-xl
        font-medium
        items-center
        justify-between;
    }
  }
</style>